import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import {FillFilters,FormatPhoneNumber} from '../../common/Utils'
import '../../common/css/searchPage.css';

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const SearchLayout = [
  {
    "groupId": 1,
    "fields": [
      {
        "name": "IDENTITYID",
        "tableName": "IDMASTER",
        "label": "Identity ID",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "IDSUBGROUP",
        "tableName": "IDMASTER",
        "label": "Subgroup",
        "type": "select",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
 

      {
        "name": "CREATIONDATETIME",
        "tableName": "IDMASTER",
        "label": "Creation Date",
        "type": "datetime",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "CREATIONUSERID",
        "tableName": "IDMASTER",
        "label": "Created By",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "AddressCITY",
        "tableName": "IDMASTER",
        "label": "City",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "AddressZIP",
        "tableName": "IDMASTER",
        "label": "Zip",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 2,
    "fields": [
  
      {
        "name": "NAME",
        "tableName": "IDMASTER",
        "label": "Name",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
    
      {
        "name": "AddressTELEPHONE1",
        "tableName": "IDMASTER",
        "label": "Telephone - 1",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },


      {
        "name": "LASTUPDATEDATETIME",
        "tableName": "IDMASTER",
        "label": "Last Updated",
        "type": "datetime",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },

      {
        "name": "LASTUPDATEUSERID",
        "tableName": "IDMASTER",
        "label": "Last Updated By",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "AddressADDRESS1",
        "tableName": "IDMASTER",
        "label": "Address - 1",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "AddressADDRESS2",
        "tableName": "IDMASTER",
        "label": "Address - 2",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 3,
    "fields": [
      {
        "name": "PROFILECODE",
        "tableName": "IDMASTER",
        "label": "Profile",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "REFERENCE1",
        "tableName": "IDMASTER",
        "label": "Reference 1",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "RECORD",
        "tableName": "IDMASTER",
        "label": "Record #",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
     
      {
        "name": "COMPANYID",
        "tableName": "IDMASTER",
        "label": "Company Id",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "MODULE",
        "tableName": "IDMASTER",
        "label": "Module",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      }
      

    
    ]
  },
  {
    "groupId": 4,
    "fields": [
      {
        "name": "IDGROUP",
        "tableName": "IDMASTER",
        "label": "Group",
        "type": "select",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "REFERENCE2",
        "tableName": "IDMASTER",
        "label": "Reference 2",
        "type": "text",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },
      {
        "name": "AddressSTATE",
        "tableName": "IDMASTER",
        "label": "State",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
      {
        "name": "AddressCOUNTRY",
        "tableName": "IDMASTER",
        "label": "Country",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      },
     
      {
        "name": "RECORDTYPE",
        "tableName": "IDADDRESS",
        "label": "Record Type",
        "type": "text",
        "required": false,
        "visible": false,
        "isLabelChanged": false,
      }

  

    ]
  }
];


const IDMasterDataEntryList = (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(false);
  const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
  const rowId = useRef(null);

  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "2BCDA668-2D5B-4D36-B8C2-A93866FDDAE8";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }, []);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, []);
  const initialFormFields = {
    IDENTITYID: '',
    NAME: '',
    PROFILECODE: '',
    IDGROUP: '',
    IDSUBGROUP: '',
    TELEPHONE_1: '',
    REFERENCE1: '',
    REFERENCE2: '',
    CREATIONDATETIME: null,
    CREATIONUSERID: '',
    AddressTELEPHONE1: '',
    REFERENCE1: '',
    REFERENCE2: '',
    LASTUPDATEDATETIME: null,
    LASTUPDATEUSERID: '',
    RECORD: '',
    COMPANYID: '',
    MODULE: '',
    AddressCITY: '',
    AddressZIP: '',
    AddressSTATE: '',
    AddressCOUNTRY: '',
    RECORDTYPE: '',
    AddressADDRESS1: '',
    AddressADDRESS2: '',

    IDTYPE: props.IdType
  };
  const [formFields, setformFields] = useState(initialFormFields);

  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length == 1) {
      rowId.current = selectedRowsData[0].rowid;
    }
    else {
      rowId.current = '';
    }

    setIsEditButtonDisabled(!isEditButtonDisabled);
  };

  const handelEditClick = () => {
    let buttonUrl = "";
   if(props.IdType==="01"){
      buttonUrl= "/wm/codes/edit-customer?id=" + rowId.current;
    }
    if(props.IdType==="02"){
      buttonUrl= "/wm/codes/edit-consignee?id=" + rowId.current;
    }
    if(props.IdType==="05"){
      buttonUrl= "/wm/codes/edit-carrier?id=" + rowId.current;
    }
    if(props.IdType==="06"){
      buttonUrl= "/wm/codes/edit-warehouse?id=" + rowId.current;
    }
    history.push(buttonUrl);
  };

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const handleSearch = (e) => {
    e.event.stopPropagation();
    let datasource=loadDatasource();
    const { IDTYPE, ...filteredFormFields } = formFields;
    const filters = FillFilters(filteredFormFields);
    datasource.filter(filters);
    setResultData(datasource);
  }
  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
  }
  useEffect(() => {
    if (formFields.IDENTITYID === '' && formFields.NAME === '' && formFields.REFERENCE1 === '' && formFields.REFERENCE2 === ''
      && formFields.IDGROUP === '' && formFields.IDSUBGROUP === '' && formFields.TELEPHONE_1 === '' && formFields.PROFILECODE === ''
    )
      setResultData(loadDatasource);
  }, [formFields]);

   useEffect(() => {
    setformFields(initialFormFields);
    if(dataGrid && dataGrid.current && dataGrid.current.instance){
      dataGrid.current.instance().clearFilter();
    }
    setResultData(loadDatasource);
  }, props.IdType);

  const handleFormLoad = useCallback(() => {
    var customerDataSource = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
        loadParams: {
          codeType: function () {
            return "Z7";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });

    loadLookupFromDataSource("IDGROUP", customerDataSource,'name','name');

    var shipperDataSource = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
        loadParams: {
          codeType: function () {
            return "Z8";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });

    loadLookupFromDataSource("IDSUBGROUP", shipperDataSource,'name','name');

  }, []);


  const loadLookupFromDataSource = (name, dataSource,valueExpr,displayExpr) => {
    if (formRefs.current[name]) {
      formRefs.current[name].instance().option('dataSource', dataSource);
      formRefs.current[name].instance().option('valueExpr', valueExpr);
      formRefs.current[name].instance().option('displayExpr', displayExpr);
    }
    else {
      console.log('not found control:');
    }
  };

  const handleFieldChange = useCallback((name, value) => {
    // console.log(name, value);
  }, []);


  const loadDatasource = () => {
    let url="";
    if(props.IdType==="01"){
      url=data.ID.GetCustomerData;
    }
    else if(props.IdType==="02"){
      url=data.ID.GetConsigneeData;
    }
    else if(props.IdType==="05"){
      url = 'id/Carrier/GetCarrierData';
    }
    else if(props.IdType==="06"){
      url=data.ID.GetWarehouseData;
    }
   let  store= createStore({
      key: 'rowid',
      loadParams: formFields,
      loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({store: store});
    dataSource.sort([
      { selector: 'identityid', desc: false },  
      { selector: 'keysequence', desc: false },  
    ]);
    return dataSource;
  }
  const [resultData, setResultData] = useState(null);


const handleValueChanged =(e)=>{
console.log(e)
}

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => {
              if (e.currentTarget === e.target) {
                selectionChanged(e, e.target);
              }
            }}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                     Enter Your Query For { props.IdType==="01" ? 'Customer' : 
                        props.IdType==="05" ? "Carrier/Ship Via" : 
                        props.IdType==="06" ? "Warehouse" : 'Consignee'
                      } Data Entry 
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
            itemRender={(itemProps) => (
              <FormField
                currrentUser={currentUser}
                layoutId='58dfc264-a700-4e77-ae3f-8431b1b92c56'
                layoutName='WMTransactionDataEntrySearchForm'
                defaultFormSchema={SearchLayout}
                formFields={formFields}
                setformFields={setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                noSpacingBeforeFirstRow={true}
              />
            )}
            id="accordion-container" className="accordion-height"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
            allowColumnReordering={true}
            allowColumnResizing={true}
            dataSource={resultData}
            showBorders={true}
            hoverStateEnabled={true}
            className="search-page-grid"
            onSelectionChanged={(e) => onSelectionChanged(e)}
            remoteOperations={true}
            searchEnabled={true}
            columnAutoWidth={true}
          >
              <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
              >
                <ColumnChooserSearch
                  enabled={true}
                  editorOptions={{ placeholder: 'Search column' }} />
              </ColumnChooser>
              <Export enabled={true} allowExportSelectedData={true} />
              <Selection mode="multiple" />
              <Sorting visible={true} mode="multiple" />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
              />
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <GroupPanel visible={true} />
              <Grouping autoExpandAll={false} />
              <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
              />
              <FilterRow visible={true} />
              <Column dataType="string" dataField="profilecode" caption="Profile" />
              <Column dataType="string" dataField="identityid" caption="Identity ID"                  
               defaultSortIndex={1} defaultSortOrder="asc"  />
              <Column dataType="string" dataField="name" caption="Name" />
              <Column dataType="string" dataField="addressADDRESS1" caption="Address" />
              <Column dataType="string" dataField="addressEMAILADDRESS1" caption="E-Mail" />
              <Column dataType="string" dataField="addressEMAILADDRESS2" caption="E-Mail2" />
              <Column visible={false} dataType="string" dataField="record" caption="Record #" />
              <Column visible={false} dataType="datetime" dataField="creationdatetime" caption="Creation Date" />
              <Column visible={false} dataType="string" dataField="creationuserid" caption="Created By" />
              <Column visible={false} dataType="datetime" dataField="lastupdatedatetime" caption="Last Updated" />
              <Column visible={false} dataType="string" dataField="lastupdateuserid" caption="Last Updated By" />
              <Column visible={false} dataType="string" dataField="companyid" caption="Company ID" />
              <Column visible={false} dataType="string" dataField="module" caption="Module" />
              <Column visible={false} dataType="string" dataField="recordtype" caption="Record Type" />
              <Column visible={false} dataType="string" dataField="idgroup" caption="Group" />
              <Column visible={false} dataType="string" dataField="idsubgroup" caption="Subgroup" />
              <Column visible={false} dataType="string" dataField="referencE1" caption="Reference 1" />
              <Column visible={false} dataType="string" dataField="referencE2" caption="Reference 2" />
              <Column visible={false} dataType="datetime" dataField="date1" caption="Date 1" />
              <Column visible={false} dataType="datetime" dataField="date2" caption="Date 2" />
              <Column visible={false} dataType="string" dataField="comment" caption="Comment" />
              <Column visible={false} dataType="string" dataField="addressADDRESSNAME" caption="Address Name" />
              <Column visible={false} dataType="string" dataField="addressADDRESS2" caption="Address 2" />
              <Column visible={false} dataType="string" dataField="addressCITY" caption="City" />
              <Column visible={false} dataType="string" dataField="addressZIP" caption="ZIP" />
              <Column visible={false} dataType="string" dataField="addressCOUNTRY" caption="Country" />
              <Column visible={false} dataType="string" dataField="addressTELEPHONE1" caption="Telephone" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
              <Column visible={false} dataType="string" dataField="addressTELEPHONE2" caption="Telephone 2" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressFAX1" caption="Fax" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressFAX2" caption="Fax 2" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressMODEM1" caption="Modem" />
              <Column visible={false} dataType="string" dataField="addressMODEM2" caption="Modem 2" />
              <Column visible={false} dataType="string" dataField="addressCELLPHONE1" caption="Cell Phone" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressCELLPHONE2" caption="Cell Phone 2" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressPAGER1" caption="Pager" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressPAGER2" caption="Pager 2" cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
              <Column visible={false} dataType="string" dataField="addressWEBSITEADDRESS1" caption="Web" />
              <Column visible={false} dataType="string" dataField="addressWEBSITEADDRESS2" caption="Web 2" />
              <Column visible={false} dataType="string" dataField="addressSTATE" caption="State" />
              <Column visible={false} dataType="string" dataField="addressCOUNTY" caption="County" />
              <Column visible={false} dataType="string" dataField="contactID" caption="Contact ID" />

              <GridToolbar>
                <GridToolbarItem location="before">
                  <Button
                    disabled={isEditButtonDisabled}
                    onClick={handelEditClick}
                    type="default"
                    text="Edit"
                  ></Button>
                </GridToolbarItem>
                <GridToolbarItem location="before">
                  <div>
                    <Link to={() => {
                    if(props.IdType === "01" ) return "/wm/codes/add-customer" ;
                    else if(props.IdType === "02") return "/wm/codes/add-consignee";
                    else if(props.IdType === "05") return "/wm/codes/add-carrier";
                    else if(props.IdType === "06") return "/wm/codes/add-warehouse";
                    }}>
                      <Button
                        type="default"
                        className="gridTopButton"
                        text="Create"
                      ></Button>
                    </Link>
                  </div>
                </GridToolbarItem>
                <GridToolbarItem name="exportButton" />
                <GridToolbarItem name="columnChooserButton" />
              </GridToolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(IDMasterDataEntryList);